import React from 'react';
import SEO from "../components/SEO.jsx";
import './Terms.css';

export default function Terms() {
  return (
    <div className="terms-container">
      <SEO
        title="Terms and Conditions | 2merative Web Design"
        description="Read the terms and conditions for 2merative web design projects, including quotations, deposits, scope changes, payment terms, and deployment."
        path="/terms"
        image="/og-image.png"
      />

      <h1 className="terms-title">Terms & Conditions</h1>

      <div className="terms-section">
        <h2>1. Quotations</h2>
        <p>
          All quotations provided by 2merative Web Design are based on the information available at the time of quoting.
          Quotes may change if project scope, requirements, timelines, or external factors change prior to acceptance.
        </p>
        <p>
          Once a deposit has been received, the quoted price is fixed and will not increase unless additional work is requested
          and agreed to in writing.
        </p>
      </div>

      <div className="terms-section">
        <h2>2. Deposit and Project Commitment</h2>
        <p>
          A minimum 50% deposit is required to secure project scheduling and commencement, unless otherwise agreed in writing.
        </p>
        <p>
          The deposit secures project scheduling, planning, and allocation of resources.
        </p>
        <p className="terms-strong">
          Deposits are non-refundable once work has commenced, except where a material breach of contract by 2merative Web Design can be demonstrated.
        </p>
      </div>

      <div className="terms-section">
        <h2>3. Cancellation and Client Withdrawal</h2>
        <p>
          Once a project has commenced, it is considered a committed engagement.
        </p>
        <p>
          If the client elects to cancel the project for any reason, all work completed to date, along with any committed project time,
          resources, and scheduling allocations, will be invoiced and become immediately payable.
        </p>
        <p>
          Where staged or fixed pricing has been agreed, 2merative Web Design reserves the right to invoice up to the full project value
          where project capacity has been allocated and cannot be reasonably reassigned.
        </p>
      </div>

      <div className="terms-section">
        <h2>4. Payment Terms</h2>
        <p>
          Staged payments may be offered to support a structured working relationship.
        </p>
        <p>Unless otherwise agreed in writing:</p>
        <ul>
          <li>50% deposit is required to commence work</li>
          <li>Remaining balance or staged payments must be paid no later than 7 days prior to deployment</li>
        </ul>
        <p>
          Failure to meet payment terms may result in delays, suspension of work, or withholding of deployment.
        </p>
      </div>

      <div className="terms-section">
        <h2>5. Scope and Variations</h2>
        <p>
          The project scope is defined at the time of quotation and agreement.
        </p>
        <p>
          Any additional features, revisions outside agreed scope, or new requirements will be treated as variations
          and may incur additional costs.
        </p>
        <p>
          All variations will be discussed and approved before work proceeds.
        </p>
      </div>

      <div className="terms-section">
        <h2>6. Client Responsibilities</h2>
        <p>
          The client is responsible for providing all required content, approvals, and feedback in a timely manner.
        </p>
        <p>
          Delays in providing content or approvals may impact timelines and do not constitute grounds for cancellation
          or refund.
        </p>
        <p className="terms-strong">
          Approval of any design, content, or stage of work constitutes acceptance of that deliverable.
        </p>
      </div>

      <div className="terms-section">
        <h2>7. Deployment</h2>
        <p>
          Deployment to a live environment will only occur once all outstanding payments have been received in full.
        </p>
        <p>
          2merative Web Design reserves the right to withhold deployment until all financial obligations are met.
        </p>
      </div>

      <div className="terms-section">
        <h2>8. Design Responsibility and Branding</h2>
        <p>
          2merative Web Design’s primary role is to design and build a website based on the client’s brief, examples, and direction provided at the time of engagement.
        </p>
        <p>
          The client is responsible for providing branding direction, including logos, colours, messaging, and overall visual identity unless otherwise agreed in writing.
        </p>
        <p>
          2merative Web Design will work collaboratively with the primary client contact to suggest design direction, layout structure, and user experience improvements to support the outcome of the project.
        </p>
        <p className="terms-strong">
          Final approval of all design and content remains the responsibility of the client. Approval at any stage constitutes acceptance of that deliverable.
        </p>
        <p>
          Unless explicitly documented in the quotation or contract, 2merative Web Design does not take responsibility for branding development, brand strategy, or brand outcomes.
        </p>
        <p>
          Any branding-related work requested outside the agreed scope will be treated as additional work and quoted separately.
        </p>
      </div>

      <div className="terms-section">
        <h2>9. Breach of Contract</h2>
        <p>
          A material breach by 2merative Web Design must be clearly demonstrated and documented.
        </p>
        <p>
          Only in such cases may remedies, including partial or full refunds, be considered.
        </p>
      </div>

      <div className="terms-section">
        <h2>10. Acceptance of Terms</h2>
        <p>
          Engagement of services and/or payment of a deposit constitutes acceptance of these Terms & Conditions and confirms the client's intention to proceed with the project as quoted.
        </p>
        <p>
         Following acceptance and project commencement, the project is considered a committed engagement. Unless a material breach of contract by 2merative Web Design can be clearly demonstrated, cancellation, withdrawal, or non-completion by the client does not remove payment obligations for work completed, committed resources, project allocation, or other amounts payable under these Terms & Conditions.
        </p>
      </div>

    </div>
  );
}
